import { render, staticRenderFns } from "./Movies.vue?vue&type=template&id=b9177e36&"
import script from "./Movies.vue?vue&type=script&lang=js&"
export * from "./Movies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports